<template>
  <div class="d-flex flex-column w-100 align-items-center">
    <p class="font-weight-bold">or</p>
    <button
      :class="['bsk-btn', 'bsk-btn-default', 'w-100', 'my-2']"
      @click.prevent="signIn('MicrosoftEntra')"
      :disabled="isDisabled"
    >
      <span v-if="!microsoftEntraLoading"
        ><i class="fab fa-microsoft"></i> Sign {{ isSignUp ? 'up' : 'in' }} with Microsoft
      </span>
      <i v-else class="fa fa-spinner fa-spin"></i>
    </button>
    <button
      :class="['bsk-btn', 'bsk-btn-default', 'w-100', 'my-2']"
      @click.prevent="signIn('Google')"
      :disabled="isDisabled"
    >
      <span v-if="!googleLoading"><i class="fab fa-google"></i> Sign {{ isSignUp ? 'up' : 'in' }} with Google </span>
      <i v-else class="fa fa-spinner fa-spin"></i>
    </button>
  </div>
</template>
<script>
import { Auth } from 'aws-amplify';
export default {
  name: 'ExternalIdentityProvider',
  data() {
    return {
      microsoftEntraLoading: false,
      googleLoading: false
    };
  },
  props: {
    action: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isSignUp() {
      return this.action === 'signUp';
    }
  },

  methods: {
    async signIn(provider) {
      this.$emit('toggle-is-disabled');

      if (provider === 'MicrosoftEntra') {
        this.microsoftEntraLoading = true;
      } else if (provider === 'Google') {
        this.googleLoading = true;
      }

      try {
        await Auth.federatedSignIn({ provider });
      } catch (error) {
        console.error(`Error during ${this.isSignUp ? 'signup' : 'signin'}:`, error);
      }
    }
  }
};
</script>
<style scoped>
.bsk-btn {
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.bsk-btn-default {
  background-color: #ffffff;
  color: #5e5e5e;
  border: 1px solid #5e5e5e;
}

.bsk-btn-default:hover {
  background-color: #f0f0f0;
}

.bsk-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
